import type { ChangeEvent, ComponentRef, HTMLAttributes, RefObject } from 'react';

import { cn } from '../lib/utils';

export type RadioProps = Omit<HTMLAttributes<HTMLInputElement>, 'onChange' | 'checked'> & {
    ref?: RefObject<ComponentRef<'input'>>;
    name?: string;
    selected?: boolean;
    onSelect?: (event: ChangeEvent<HTMLInputElement>) => void;
    color?: string;
    disabled?: boolean;
};

export function Radio({ ref, className, selected, onSelect, name, color, disabled, ...props }: RadioProps) {
    return (
        <input
            type="radio"
            checked={selected}
            onChange={onSelect}
            name={name}
            className={cn(
                'peer min-h-4 min-w-4 appearance-none rounded-full border border-input-border ring-offset-background transition-all checked:border-[4px] checked:border-brand-primary hover:border-input-border-hover checked:hover:border-brand-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            style={color
                ? {
                        borderColor: selected ? color : undefined,
                    }
                : undefined}
            disabled={disabled}
            {...props}
        />
    );
}

Radio.displayName = 'Radio';
